module.exports = __webpack_public_path__ + "img/LifeThumbnail.acf7bb0d.png";